import { CacheProvider } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import type { ReactNode } from "react";

import { useThemeStore } from "@/stores/theme.store";
import { emotionCacheRtl } from "@/theme/emotionCache";
import { createAppTheme } from "@/theme/theme";

type Props = {
  children: ReactNode;
};

export default function ThemeProvider({ children }: Props) {
  const mode = useThemeStore((s) => s.mode);
  const theme = createAppTheme(mode);
  return (
    <CacheProvider value={emotionCacheRtl}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </CacheProvider>
  );
}
